import { render } from "./LazyBaseTextarea.vue?vue&type=template&id=42c5df62&scoped=true"
import script from "./LazyBaseTextarea.vue?vue&type=script&lang=ts"
export * from "./LazyBaseTextarea.vue?vue&type=script&lang=ts"

import "./LazyBaseTextarea.vue?vue&type=style&index=0&id=42c5df62&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-42c5df62"

export default script